import { Flex } from '@chakra-ui/react';
import Card from 'components/card/Card';
import { useEffect, useState } from 'react';
import SearchTableOrders from './components/SearchTableOrders';

type EncuestaRow = {
  id: number;
  Titulo?: string | null;
  Acceso: string;
  FechaI?: string | null;
  FechaF?: string | null;
  createdAt?: string | null;
  Bloqueada?: boolean;
};

export default function RegistroEncuesta() {
  const [data, setData] = useState<EncuestaRow[]>([]);
  const [isLoading, setIsLoading] = useState(true);

  useEffect(() => {
    const fetchData = async () => {
      try {
        const response = await fetch(process.env.REACT_APP_URL_SERVER + '/encuestas', {
          credentials: 'include',
        });
        const result = await response.json();
        setData(Array.isArray(result) ? result : []);
      } catch (error) {
        console.error('Error fetching encuestas:', error);
        setData([]);
      } finally {
        setIsLoading(false);
      }
    };

    fetchData();
  }, []);

  return (
    <Flex direction="column" pt={{ sm: '125px', lg: '75px' }}>
      <Card px="0px">
        {!isLoading && <SearchTableOrders tableData={data} />}
      </Card>
    </Flex>
  );
}
